import { Type } from 'class-transformer';
import {
  IsArray,
  IsBoolean,
  IsNotEmpty,
  IsOptional,
  IsString,
  MaxLength,
  MinLength,
  ValidateNested,
} from 'class-validator';
import { BaseDto } from '../../../../@base/base.dto';
import { MessageId } from '../../../../types';

export class MessageFlaggedDto {
  @IsBoolean()
  isFlagged!: boolean;

  @IsArray()
  @IsString({ each: true })
  reasons!: string[];
}

export class SendMessageDto {
  @IsString()
  @IsNotEmpty()
  @MinLength(2)
  @MaxLength(4000)
  text!: string;

  @IsOptional()
  @IsString()
  replyTo?: string;
}

export enum MessageType {
  CHAT = 'chat',
  ACTION = 'action',
  SYSTEM = 'system',
}

export class MessageDto extends BaseDto<MessageId> {
  @IsString()
  @IsNotEmpty()
  discussion!: string;

  @IsString()
  @IsNotEmpty()
  sender!: string;

  @IsString()
  @IsNotEmpty()
  @MinLength(2)
  @MaxLength(4000)
  text!: string;

  @IsArray()
  @IsString({ each: true })
  readBy!: string[];

  @IsOptional()
  replyTo?: MessageDto & { id?: string };

  @IsOptional()
  @ValidateNested()
  @Type(() => MessageFlaggedDto)
  flagged?: MessageFlaggedDto;

  @IsOptional()
  type?: MessageType | string;

  @IsOptional()
  @IsString()
  actionType?: string;

  @IsOptional()
  actionData?: Record<string, unknown>;
}
